module.exports = __webpack_public_path__ + "static/media/blueBillPayment.4b95d5cf.svg";